import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
class Container extends Vue {
}

export default Container;


// WEBPACK FOOTER //
// ./src/components/empty/index.ts